import Yggdrasil from 'services/yggdrasil'
import { getCurrentMemberId } from 'services/yggdrasil/api/aesirApi'

const state = {
    remoteVideoLogs: [],
    courses: [],
    lastSavedLogEntryHash: null,
    errorException: false,
    nonLoggedException: false
}

const mutations = {
    ASSIGN_REMOTE_VIDEO_LOGS (state, videoLogs) {
        state.remoteVideoLogs = videoLogs
    },
    COURSES_FOR_VIDEO_LOGS (state, courses) {
        state.courses = courses
    },
    CLEAR_AFTER_LOGOUT (state) {
        state.courses = []
        state.remoteVideoLogs = []
    },
    UPDATE_LAST_SAVED_ENTRY (state, hash) {
        state.lastSavedLogEntryHash = hash
    },
    SET_ERROR_EXCEPTION (state, value) {
        state.errorException = value
    },
    SET_NON_LOGGED_EXCEPTION (state, value) {
        state.nonLoggedException = value
    }
}

const actions = {
    async clearAfterLogout (store) {
        store.commit('CLEAR_AFTER_LOGOUT')
    },
    async loadVideoLogForCourseAndVideo (store, { courseId, videoId }) {
        return Yggdrasil.loadVideoLogForCourseAndVideo(courseId, videoId)
    },
    async loadVideoLogForMicroLearningElements (store, { courseId }) {
        return Yggdrasil.loadVideoLogForMicroLearningElements(courseId)
    },
    async pushVideoLogForCourseAndVideo (store, { courseId, videoId, position, watched, durationSeconds, timeRanges }) {
        let objToSave = {
            durationSeconds: durationSeconds,
            totalWatched: watched,
            details: {
                timeRanges
            },
            position
        }
        if (isNewVideoLogEntryValid(store.state, courseId, videoId, objToSave)) {
            try {
                await Yggdrasil.saveVideoLogForCourseAndVideo(courseId, videoId, objToSave)
                store.commit('UPDATE_LAST_SAVED_ENTRY', createHashOfSend(courseId, videoId, objToSave))
                setErrorExceptionToFalse(store)
            } catch (exp) {
                if (getCurrentMemberId() === 0) {
                    store.commit('SET_NON_LOGGED_EXCEPTION', true)
                }
                store.commit('SET_ERROR_EXCEPTION', true)
                store.commit('UPDATE_LAST_SAVED_ENTRY', null)
            }
        }
    },
    async clearLatestVideoLogEntry (store, payload) {
        store.commit('UPDATE_LAST_SAVED_ENTRY', null)
    },
    async loadVideoLogs (store) {
        const list = await Yggdrasil.loadVideologs()
        store.commit('ASSIGN_REMOTE_VIDEO_LOGS', list)
    },
    async loadCoursesForVideolog (store) {
        const list = await Yggdrasil.loadCoursesForVideolog()
        store.commit('COURSES_FOR_VIDEO_LOGS', list)
    },
    resetErrorException (store) {
        setErrorExceptionToFalse(store)
    }
}

const getters = {
    remoteVideoLogs: (state) => state.remoteVideoLogs,
    getCoursesForVideoLogs: (state) => state.courses,
    remoteVideoLogsForCourseAndVideo: (state) => (courseId, videoId) => state.remoteVideoLogs.find(remoteVideoLog => {
        return +remoteVideoLog.courseId === +courseId && remoteVideoLog.videoId === +videoId
    }),
    isCourseHalfWatched: (state) => (courseId) => {
        let videoLogCourse = state.remoteVideoLogs.find(el => +el.course_id === +courseId)
        if (!videoLogCourse || !videoLogCourse.duration_seconds) {
            return false
        } else {
            return (videoLogCourse.total_watched / videoLogCourse.duration_seconds) > 0.5
        }
    },
    getVideoLogWithCourseId: (state) => (courseId) => {
        return state.remoteVideoLogs.find(el => +el.course_id === +courseId)
    },
    getErrorException: (state) => state.errorException,
    getNonLoggedException: (state) => state.nonLoggedException
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

function isNewVideoLogEntryValid (state, courseId, videoId, objToSave) {
    /**
     * Exceptional but possible:
     * invalid time ranges sometimes ranges of time are from higer to lower and we don't know why
     * #TODO: investigate why, fix a problem and then remove this line.
     **/
    if (objToSave.details.timeRanges.find(range => range[1] < range[0])) {
        return false
    }
    if (state.lastSavedLogEntryHash === createHashOfSend(courseId, videoId, objToSave)) {
        return false
    }
    return true
}

function createHashOfSend (courseId, videoId, objToSave) {
    return JSON.stringify({ courseId, videoId, objToSave })
}

function setErrorExceptionToFalse (store) {
    store.commit('SET_ERROR_EXCEPTION', false)
    store.commit('SET_NON_LOGGED_EXCEPTION', false)
}
